import React, {useEffect, useState} from 'react';
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Link, useParams} from "react-router-dom";
import { SalesRegisterCreateRoute, SalesRegisterEditRoute, SalesRegisterListRoute} from "../../routesConstants";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import DataTable from "../../../components/dataTable";
import axios from "../../../helpers/axios";
import SearchSelect from "../../../components/searchSelect";
import {Form} from "react-bootstrap";
import {Helmet} from "react-helmet";
import moment from "moment";
import sayError from "../../../helpers/sayError";
import numberFormat from "../../../helpers/numberFormat";


const tempQuery = {
  buyer:'',
  deleted:false
}
const ListSalesRegister = () => {
  const {id} = useParams();
  const [query,setQuery] = useState({
    buyer: id,
    deleted: false
  })
  const [list, setList]=useState(null)
  const [refetch, setRefetch] = useState()
  const [loading, setLoading] = useState()
  const [lastDate, setLastDate] = useState(moment().subtract(7, 'days').format('DD.MM.YYYY'))
  useEffect(() => {
    axios.post('/api/counterparty/searchInput', )
      .then(({data})=>{
        setList(data.data)
      })
  }, []);
  console.log("lastDate",lastDate)
  const columns = [
    {
      Header: 'Покупатель',
      accessor: 'counterparty',
      Cell: ({value, row}) => <Link to={SalesRegisterEditRoute + row.original.id+`?start=${row.original.start}&buyerId=${row.original.counterpartyId}`}
                                    >{value}</Link>
    },
    {
      Header: 'Период',
      accessor: 'period',
    },
    {
      Header: 'Создан когда/кем',
      accessor: 'createdDate',
      Cell: ({value, row}) => <span>{value} {row.original.createdBy}</span>
    },
    {
      Header: 'Сумма',
      accessor: 'total',
      Cell: ({value, row}) => <span>{numberFormat(value)}</span>
    },
    {
      Header: 'Оплачен',
      accessor: 'isPaid',
      Cell: ({value, row}) => <div style={{marginLeft:20}}>{value ? <i className="fa fa-check-circle text-success"/> :
        <i className="fa fa-times-circle text-danger"/>} </div>
    },
  ]

  const markPaid = (id) =>{
    if (window.confirm('Вы уверены?')){
      setLoading(id)
      axios.post('/api/salesRegister/markPaid/'+id)
        .then(()=>{
          setRefetch(Math.random())
        })
        .catch(sayError)
        .finally(()=>setLoading())}
    }


  return (
    <>
      <Helmet>
        <title>Реестры продаж</title>
      </Helmet>
      <Breadcrumbs aria-label="Breadcrumb" style={{paddingBottom: 15}}>
        <Link to={SalesRegisterListRoute}>Список покупателей</Link>
        <Typography color="textPrimary">Список реестров</Typography>
      </Breadcrumbs>
        <Portlet>
          <PortletHeader title={'Список реестров продаж'} toolbar={
            <PortletHeaderToolbar>
              {list && <>
                <div style={{width: 200, marginLeft: 4}}>
                  <SearchSelect
                    onChange={v => {
                      console.log('v', v)
                      setQuery(q => ({...q, buyer: v}))
                      window.history.pushState({}, null, `/salesRegister/list/${v}`)
                    }}
                    defaultValue={query.buyer}
                    label={'Покупатель'}
                    array={list}/>
                </div>
                <Form.Label className={'d-flex align-items-center gap-2 m-2'}>
                  <input
                    defaultChecked={query.deleted}
                    onChange={(e) => {
                      setQuery(q => ({...q, deleted: e.target.checked}))
                    }}
                    type={"checkbox"}
                  />{" "}
                  Удаленные
                </Form.Label>

              </>}

              <Link to={SalesRegisterCreateRoute+`?start=${lastDate}&end=${moment().subtract(1, 'days').format('DD.MM.YYYY')}&id=${id}&loading=false`}
                    className="btn btn-sm btn-primary">
                <i className="la la-plus"/>
                Добавить
              </Link>

            </PortletHeaderToolbar>
          }/>
          <PortletBody>
            <DataTable columns={columns}
                       refetch={refetch}
                       cb={(items)=>{
                         items.length>0 && setLastDate(moment(items[0].end, 'DD.MM.YYYY').add(1,'day').format("DD.MM.YYYY"))
                       }}
                       search={query}
                       url={`/api/salesRegister/list/`+query.buyer}/>
          </PortletBody>
        </Portlet>

    </>

  );
};

export default ListSalesRegister;
